import instance from 'config/interceptor';

export const getSmsBlast = async () => {
  try {
    return await instance.get(process.env.REACT_APP_URL + `/LogSms/Slice`);
  } catch (error) {
    return error;
  }
};
